// types
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'store';

// initial state
interface NotificationState {
    isProgress: boolean;
    isOpen: boolean;
    alert: boolean;
}
const initialState: NotificationState = {
    isProgress: false,
    isOpen: false,
    alert: false
};

// ==============================|| SLICE - NOTIFICATION ||============================== //

const notification = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setIsOpen(state, action) {
            state.isOpen = action.payload;
        },
        setIsProgress(state, action) {
            state.isProgress = action.payload;
        },
        openAlert(state, action) {
            state.alert = action.payload;
        }
    }
});

export default notification.reducer;

export const { setIsProgress, setIsOpen, openAlert } = notification.actions;

// ----------------------------[ NOTIFICATION ]----------------------------
